var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form-item',{attrs:{"label":_vm.label}},[_c('el-select',_vm._g({attrs:{"value":_vm.value,"filterable":"","clearable":""}},_vm.$listeners),_vm._l((_vm.modelList),function({ groupName, groupId }){return _c('el-option',{key:groupId,attrs:{"label":groupName,"value":groupId}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }